/** Vue CLI publicPath，部署在子路径时通常为 /kg/ */
export function getAppBasePath() {
  const base = process.env.BASE_URL || "/";
  if (!base || base === "/") {
    return "/";
  }
  return base.endsWith("/") ? base : `${base}/`;
}

/** 回到应用首页；子路径部署时用完整 URL 跳转，避免 /kg 无尾斜杠导致 Nginx 404 */
export function goAppHome() {
  const base = getAppBasePath();
  if (base === "/") {
    import("@/router").then(({ default: router }) => {
      router.replace("/");
    });
    return;
  }
  window.location.replace(base);
}
